<template>
  <v-card class="text-xs-center">
    <h1 class="text-pagename">Package Management</h1>
    <!-- <packageListTable/> -->
    <packageListCard />
  </v-card>
</template>

<script>
// import packageListTable from "../../../components/back-office/Package/PackageListTable";
import packageListCard from "@/components/back-office/Package/PackageListCard";
export default {
  components: {
    // packageListTable,
    packageListCard,
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },

      {
        text: "Package list",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style scoped>
</style>